<div><canvas [id]="id"></canvas></div>
